/**
 * Store home of the account, or of a partner store
 * (`/store/<lang>/p/<slug>`). Without a leading slash.
 *
 * @function storeHomePath
 * @since 1.0.0
 */
export function storeHomePath(language, partnerSlug) {
    const lang = language === 'fr' ? 'fr' : 'en';
    return partnerSlug ? `store/${lang}/p/${partnerSlug}` : `store/${lang}`;
}
/**
 * Same store in the other language.
 *
 * @function storeLanguageSwitchPath
 * @since 1.0.0
 */
export function storeLanguageSwitchPath(language, partnerSlug) {
    return storeHomePath(language === 'en' ? 'fr' : 'en', partnerSlug);
}
/**
 * Product feed of a store, from its absolute URL
 * (`https://…/store/<lang>` or `https://…/store/<lang>/p/<slug>`).
 *
 * @function storeFeedUrl
 * @since 1.0.0
 */
export function storeFeedUrl(storeUrl, channel) {
    return `${storeUrl.replace(/\/+$/, '')}/feed/${channel}.xml`;
}
